const userLists = {
  userLists: 'Список пользователей администратора',
  showing: 'Показано',
  userListsOf: 'пользователи',
  noUserListsFound: 'Пользователи не найдены',
  actionsDropdown: {
    details: 'Детали',
    deactivate: 'Деактивировать',
    edit: 'Редактировать',
  },
  modal: {
    editUser: 'Редактировать пользователя',
    name: 'Имя',
    email: 'Электронная почта',
    role: 'Роль',
    messengers: 'Ссылки',
    priceplan: 'Ценовой план',
    manager: 'Менеджер',
    isAlive: 'Активный',
    emailVerified: 'Электронная почта подтверждена',
    successUpdate: 'Изменения к пользователям успешно применены.',
  },
  tableDropdown: {
    quickActions: 'Меню быстрых действий',
    refresh: 'Обновить',
    exportUserList: 'Экспорт',
    exportUserListCurrent: 'Экспортировать текущий',
  }
};

export default userLists;
